import React, { useEffect, useState } from "react";
import { Download, Share, PlusSquare, MoreVertical } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";

const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent || "");
const isStandalone = () => window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone;

export const InstallAppButton = ({ className = "", label = "Baixar app", testid = "btn-install-app" }) => {
  const [prompt, setPrompt] = useState(window.__installPrompt || null);
  const [help, setHelp] = useState(false);
  const [installed, setInstalled] = useState(isStandalone());

  useEffect(() => {
    const onReady = () => setPrompt(window.__installPrompt);
    const onDone = () => setInstalled(true);
    window.addEventListener("install-prompt-ready", onReady);
    window.addEventListener("appinstalled", onDone);
    return () => { window.removeEventListener("install-prompt-ready", onReady); window.removeEventListener("appinstalled", onDone); };
  }, []);

  if (installed) return null;

  const click = async () => {
    if (prompt) {
      prompt.prompt();
      const { outcome } = await prompt.userChoice;
      if (outcome === "accepted") setInstalled(true);
      window.__installPrompt = null; setPrompt(null);
      return;
    }
    setHelp(true);
  };

  return (
    <>
      <button onClick={click} className={`inline-flex items-center gap-2 ${className}`} data-testid={testid}>
        <Download size={14}/> {label}
      </button>
      <Dialog open={help} onOpenChange={setHelp}>
        <DialogContent data-testid="install-help-dialog">
          <DialogHeader><DialogTitle className="font-serif text-2xl">Instale o app Arya Studio</DialogTitle></DialogHeader>
          {isIOS() ? (
            <ol className="space-y-3 text-sm">
              <li className="flex items-center gap-2">1. Abra este site no <b>Safari</b>.</li>
              <li className="flex items-center gap-2">2. Toque em <Share size={16}/> <b>Compartilhar</b> (barra de baixo).</li>
              <li className="flex items-center gap-2">3. Escolha <PlusSquare size={16}/> <b>Adicionar à Tela de Início</b> e toque em Adicionar.</li>
            </ol>
          ) : (
            <ol className="space-y-3 text-sm">
              <li className="flex items-center gap-2">1. Abra este site no <b>Google Chrome</b> do celular.</li>
              <li className="flex items-center gap-2">2. Toque no menu <MoreVertical size={16}/> (canto de cima).</li>
              <li className="flex items-center gap-2">3. Escolha <b>Instalar app</b> ou <b>Adicionar à tela inicial</b>.</li>
            </ol>
          )}
          <p className="text-xs text-[color:var(--ink-500)]">O ícone de girassol aparece na tela do seu celular, como um app.</p>
        </DialogContent>
      </Dialog>
    </>
  );
};
